
















































































import {
  Vue,
  Component,
  VueComponent,
  InjectComponent,
  FlowStep,
  Prop,
  ProductRecommendation,
} from "@zoovu/runner-browser-api";
import { AdviceView } from "@zoovu/runner-web-design-base";

interface AdditionalClusterData {
  classList: string;
  clusterHeadline: string;
  clusterSubHeadline: string;
}

@Component({
  name: "AdviceView",
  mixins: [AdviceView],
})
export default class AdviceViewExtended extends Vue {
  @InjectComponent("AdviceFiltersView")
  adviceFiltersView: VueComponent;

  get adviceWrapperClass(): Record<string, unknown> {
    return {
      "advice-filters-wrapper": this.canRenderFilters,
    };
  }

  get areTopProductsAvailable(): boolean {
    return this.topProducts.length && this.advice.currentPage.pageNumber === 0;
  }

  get indexOfFirstClusterWithProducts(): number {
    return this.currentPageClustersExtended.findIndex(({ products }) => products.length);
  }

  clusterWrapperClass(index: number): Record<string, unknown> {
    return {
      "cluster-wrapper": true,
      "first-cluster-with-products": index === this.indexOfFirstClusterWithProducts,
    };
  }
}
